import { useMemo } from "react";
import { required } from "../../../../../../helpers/forms/validate.js";
import useSearcherDatesInput from "../../../../../../hooks/common/searchers/inputs/useDatesInput.js";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import useValue from "../../../../../../hooks/forms/useValue.js";
import { useSearcherFlightHotelProps, useSearcherFlightHotelState } from "../../context/index.js";
import useSearcherFlightHotelDefaultValues from "../../hooks/useSearcherFlightHotelDefaultValues.js";
const useEvents = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { flightOperative  } = state ?? {};
    const datesValue = useValue({
        name: 'dates'
    });
    return useMemo(()=>[
            {
                legend: {
                    text: literals?.legent ?? '',
                    class: 'flatpickr-day-footer-literal'
                },
                date: {
                    dates: (datesValue?.length === 1 ? flightOperative?.checkouts : flightOperative?.checkins)?.filter((checkin)=>checkin.s === 0 && !!checkin.d)?.map((checkin)=>checkin.d) ?? [],
                    class: 'flatpickr-day--direct-flight'
                }
            }
        ], [
        flightOperative,
        literals?.legent,
        datesValue?.length
    ]);
};
const useLiterals = ()=>{
    const props = useSearcherFlightHotelProps();
    const { config  } = props ?? {};
    const { literals  } = config ?? {};
    const isMobile = useIsMobile();
    if (isMobile) return {
        startDateLabel: literals?.checkIn ?? '',
        endDateLabel: literals?.checkOut ?? '',
        modalTitle: literals?.checkInLabel ?? '',
        modalConfirm: literals?.accept ?? ''
    };
    return {
        label: literals?.calendarLabel ?? ''
    };
};
const useDatesInput = ()=>{
    const props = useSearcherFlightHotelProps();
    const { dates , config  } = props ?? {};
    const { onModal =false  } = config ?? {};
    const state = useSearcherFlightHotelState();
    const { isLoading , flightOperative  } = state ?? {};
    const isMobile = useIsMobile();
    const defaultValues = useSearcherFlightHotelDefaultValues(props);
    const originValue = useValue({
        name: 'origin'
    });
    const destinationValue = useValue({
        name: 'destination'
    });
    const requiredValidation = useMemo(()=>[
            required()
        ], []);
    const events = useEvents();
    const datesLiterals = useLiterals();
    const datesInput = useSearcherDatesInput({
        disabled: !originValue || !destinationValue || isLoading,
        defaultValue: defaultValues.dates,
        validate: requiredValidation,
        minDate: 'today',
        releaseDays: dates?.releaseDays ?? 1,
        checkIn: flightOperative?.checkins?.filter((item)=>!!item.d)?.map((item)=>item.d) ?? [],
        checkOut: flightOperative?.checkouts?.filter((item)=>!!item.d)?.map((item)=>item.d) ?? [],
        enableAllDays: true,
        events,
        ...datesLiterals
    });
    if (isMobile) return datesInput;
    return {
        ...datesInput,
        showMonths: onModal ? 1 : 2
    };
};
export default useDatesInput;

//# sourceMappingURL=useDatesInput.js.map